import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import BellNotifiaction from '../BellNotifiaction';
import Modal from "react-modal";

Modal.setAppElement("#root");
export default function Our_producthome() {

  const [fname2, setfname2] = useState("");
  const [newfile2, setNewfile2] = useState(null);
  const [newdata2, setnewdata] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const handleImageClick = (imageSrc) => {
    setSelectedImage(imageSrc);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };
const history = useNavigate();


  const setData2 = (e) => {
    const { value } = e.target;
    setfname2(value);
  };
  const setimgfile = (e) => {
    setNewfile2(e.target.files[0]);
  };

  // Add image

  const adduserdata2 = async (e) => {
    
    var formdata2 = new FormData();
    console.log(newfile2);
    var filename = newfile2.name;
    formdata2.append("photo2", newfile2, filename);
    formdata2.append("fname2", fname2);
    console.log(formdata2);

    const config = {
      headers: {
        "Content-Type": " multipart/form-data",
      },
    };

    const res = await axios.post(
      "https://pratik-agro-backend.vercel.app/AddHomeproduct",
      formdata2,
      config
    );
    history("/Our_producthome");
    console.log(res);
  };
  //get image

  const getUserData2 = async () => {
    const res = await axios.get("https://pratik-agro-backend.vercel.app/getHomeproductImg", {
      headers: {
        "Content-Type": " application/json",
      },
    });
    if (res.data.status === 401 || !res.data) {
      console.log("error");
    } else {
      setnewdata(res.data.getImage.reverse());
    }
  };
  useEffect(() => {
    getUserData2();
  }, []);
 
//delete data
const deleteimage = async (id) => {
 
  const res3 = await fetch(`https://pratik-agro-backend.vercel.app/deletedata2/${id}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
  });
  const deleteStud2 = await res3.json();
  console.log(deleteStud2);
  if (res3.status === 422 || !deleteStud2) {
    console.log("error");
  } else {
    getUserData2();
  }

};
  return (
    <div  className="content">


<div className="mt-2 mb-1 d-flex justify-content-between align-items-center">
        <i>
          <h2>Our Product</h2>
        </i>
       <div>
     
       <BellNotifiaction />
       <Link
          type="button"
          to="/Addhomeimage"
          className="btn btn-light shadow addimage "
          data-bs-toggle="modal"
          data-bs-target="#staticBackdrop"
        >
          Add Image
        </Link>
       </div>
        
        
      </div>
     <div className=" container text-end mt-5">
        {/* <Link  to="/Addhomeimage"className="btn btn-success "> Add Data</Link> */}
        
        <div
          class="modal fade "
          id="staticBackdrop"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabindex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog ">
            <div class="modal-content">
              <div class="modal-header">
                <h1 class="modal-title fs-5" id="staticBackdropLabel">
                  Home Image
                </h1>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div class="modal-body">
                <form>
                  <div>
                    
                      <p style={{float:'left'}}>Product Name:-</p>
                    
                    <input
                      type="text"
                      name="fname2"
                      className="form-control"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      onChange={setData2}
                    />

                    <div>
                      <p style={{float:'left'}}>Add Your Image:-</p>
                    </div>
                    <input
                      type="file"
                      name="photo2"
                      className="form-control"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      onChange={setimgfile}
                    />
                    <button
                      type="submit"
                      className="btn btn-primary mt-5"
                       onClick={adduserdata2}
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="outer-wrapper">
    <div class="table-wrapper">
      <table class="table  mt-5">
        <thead className="bg-dark text-white ">
          <tr>
            <th scope="col">ID</th>
            <th scope="col">Product Image</th>
            <th scope="col">Product Name</th>
            <th scope="col">Uploaded Date</th>
            <th scope="col">Action</th>
            
          </tr>
          </thead>
          <tbody>
          {newdata2.length>0 ?newdata2.map((el,id) => {
            console.log(el)
            return (
              <>
                <tr>
                  <th scope="row mt-5">{id+1}</th>
                  <td><img src={el.productimgpath} alt='img'  style={{'width':'70px',textAlign:"center",margin:'auto', cursor:"pointer"}} onClick={() => handleImageClick(el.productimgpath)}/></td>
                  <td>{el.fname2}</td>
                  <td>{el.date}</td>
                  {/* <td>
                    <NavLink to={`/Edit/${el._id}`}><i className="bi bi-pencil-square p-4 shadow"  ></i></NavLink>
                    <i class="bi bi-archive-fill p-4 shadow" onClick={()=>deleteimage(el._id)}></i>
                  </td> */}
                  <td>
                        <button type="button" class="btn btn-outline-dark "><NavLink to={`/HomeproductEdit/${el._id}`}><i className="bi bi-pencil-square "  ></i></NavLink></button>
                        <button type="button" class="btn btn-outline-dark "><i class="bi bi-archive-fill " onClick={()=>deleteimage(el._id)}></i></button>
                  </td>
                </tr>
              </>
            );
          }):"Loading..."
          } 
        </tbody>
        <Modal isOpen={isModalOpen} onRequestClose={handleCloseModal} style={{ content: { width: '50%', height: '50%', margin: 'auto', backgroundColor: 'white' } }}>
     <button onClick={handleCloseModal} className="btn btn-danger"><i class="bi bi-x-lg"></i></button>
  <div className='text-center mt-5'>
    <img src={selectedImage} alt="img" style={{width: '30%', height: '35%%'}} className='text-center' />
  </div>
  
</Modal>
      </table>
      </div>
</div>
    </div>
  )
}